import type { Ari } from '@atlassian/jira-platform-ari';
import { type CloudId, toIssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { TopFilter } from '../types';
import { createIssueAri, createIssueTypeAri } from './ari';

type IssueTypeIdsRelay = ReadonlyArray<string> | null | undefined;
type EpicIdsRelay = ReadonlyArray<string | null | undefined> | null | undefined;

type TopFilterServiceShape = {
	issueTypeIds: Ari[] | IssueTypeIdsRelay;
	epicIds: (Ari | null)[] | EpicIdsRelay;
};

export const toServiceShapeTopFilter = (
	cloudId: CloudId,
	filters: TopFilter,
): TopFilterServiceShape => ({
	issueTypeIds: filters.issueTypeIds.map((issueTypeId) => createIssueTypeAri(cloudId, issueTypeId)),
	epicIds: filters.epicIds.map((epicId) =>
		epicId === null ? null : createIssueAri(cloudId, toIssueId(epicId)),
	),
});
